import { Component, OnInit } from "@angular/core";
import { UserService } from "../../services/user/user.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { MzToastService } from "ng2-materialize";

@Component({
  selector: "app-new-password",
  templateUrl: "./new-password.component.html",
  styleUrls: ["./new-password.component.scss"],
})
export class NewPasswordComponent implements OnInit {
  env: any = environment;
  password: string;
  error: string;
  form: FormGroup;
  confirmPassword = "" as string;
  recoveryToken: string;
  loading: boolean;
  userErrorMessage: string;
  userSuccessMessage: string;

  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private toastService: MzToastService
  ) {}

  errorMessages = {
    password: {
      required: "Bitte gib ein Passwort an.",
      pattern: "Bitte gib mindestens 6 Zeichen ein.",
      validateEqual: "Bitte wiederhole Dein Passwort.",
    },
    confirmPassword: {
      required: "Bitte wiederhole Dein Passwort.",
      pattern: "Bitte gib mindestens 6 Zeichen ein.",
      validateEqual: "Die Passwörter müssen übereinstimmen.",
    },
  };

  ngOnInit() {
    this.route.params.subscribe((params: { token: string }) => {
      if (!params.token) {
        this.error = "No token found.";
        this.userSuccessMessage = null;
        this.userErrorMessage =
          "Dein Link zum Zurücksetzen des Passworts ist abgelaufen. Bitte setze es erneut zurück.";
      } else {
        this.recoveryToken = params.token;
        this.checkRecoveryToken();
        setTimeout(() => {
          $("#email").focus();
          $("#email").select();
        }, 100);
      }
    });
    this.form = new FormGroup({
      password: new FormControl(this.password, Validators.required),
      confirmPassword: new FormControl(
        this.confirmPassword,
        Validators.required
      ),
    });
  }

  private checkRecoveryToken() {
    this.loading = true;
    this.userService
      .checkRecoveryToken(this.recoveryToken)
      .then(() => {
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        this.error = error.error.message;
        this.userSuccessMessage = null;
        this.router.navigate(["/forgot-password"], {
          queryParams: { expired: true },
        });
      });
  }

  setNewPassword() {
    if (this.form.valid) {
      this.userErrorMessage = null;
      this.loading = true;
      console.log(this.recoveryToken);
      this.userService
        .setNewPassword({
          token: this.recoveryToken,
          password: this.password,
        })
        .then((response) => {
          this.loading = false;
          this.router.navigate(["/login"], { queryParams: { pwreset: true } });
        })
        .catch((error) => {
          this.loading = false;
          this.error = error.error.message;
          this.userSuccessMessage = null;
          this.userErrorMessage = "Bitte überprüfe Deine Daten.";
        });
    } else {
      this.userSuccessMessage = null;
      this.userErrorMessage = "Bitte überprüfe Deine Daten.";
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/new-password/new-password.component.ts